import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { ExactNavLink } from './ExactNavLink';


const classNames = (...classes) => {
  return classes.filter(Boolean).join(' ')
}


const NBATabs = ({items}) => {

    useEffect(() => {
        const scrollContainer = document.getElementsByClassName('horizontal-scroll');
        if(scrollContainer?.length > 0) {
            scrollContainer[0].addEventListener('wheel', (e) => {
                e.preventDefault();
                scrollContainer[0].scrollLeft += e.deltaY;
            }, { passive: false });
        }
    }, [])



  return (
    <div className='w-full flex flex-col '>
      <div className="block px-2 py-2 sticky top-[55px] z-51 bg-[#f6f6f6]">
        <div className="flex flex-row justify-center  "> 
          {/* sm:pl-12 md:pl-16 sm:justify-start */}
          <nav className="-mb-px flex flex-4  space-x-4 xs:space-x-8 sm:space-x-8 md:space-x-8 lg:space-x-8 overflow-x-scroll hide-scrollbar horizontal-scroll" aria-label="Tabs">
            {items.map((x) => (
              
              x?.exact ?
              <ExactNavLink 
                key={x.linkUrl}
                to={x.linkUrl}
                end
                target={x.externalLink ? '_blank' : '' }
                className={(e) => {
                  return classNames(
                    e.isActive ? 'border-[#FBCD44] text-black' : 'border-transparent text-[#4E525C] hover:border-gray-300 hover:text-black',
                  'group text-lg inline-flex items-center border-b-2  my-1 px-1 font-medium hover:no-underline',
                  
                )}}
              >
                <span className="truncate" style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}}>{x.header}</span>
              </ExactNavLink>
              : <NavLink 
                key={x.linkUrl}
                to={x.linkUrl}
                end
                target={x.externalLink ? '_blank' : '' }
                className={(e) => {
                  return classNames(
                    e.isActive ? 'border-[#FBCD44] text-black' : 'border-transparent text-[#4E525C] hover:border-gray-300 hover:text-black',
                  'group text-lg inline-flex items-center border-b-2  my-1 px-1 font-medium hover:no-underline',
                  
                )}}
              >
                <span className="truncate" style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}}>{x.header}</span>
              </NavLink>
            ))}

          </nav>
          
        </div>
      </div>
    </div>
  )
};

export default NBATabs;